import * as helpers from '@marketplace/helpers/datetime.js'

/**
 * Add the date time helpers to the Nuxt context
 *
 * @param {object} context
 * @param {object} context.store
 * @param {Function}  inject
 */
export default function ({ store }, inject) {
    inject('datetime', helpers)
}
